import type { TFunction } from 'i18next';

import type { WebsiteTabId } from './tabs';

/**
 * Each Website area's name and one-line description, shared by the hub cards and the area header. Literal `t()`
 * calls per case, so the extractor harvests every key; the `switch` is exhaustive, so a new area fails the
 * typecheck until it has its copy.
 */

export const areaTitle = (t: TFunction, id: WebsiteTabId): string => {
  switch (id) {
    case 'creatives':
      return t('Website Creatives');
    case 'logos':
      return t('Logos');
    case 'art-style':
      return t('Art Style');
    case 'games':
      return t('Game Lists');
    case 'blog':
      return t('Blog');
    case 'seo':
      return t('SEO');
  }
};

export const areaDescription = (t: TFunction, id: WebsiteTabId): string => {
  switch (id) {
    case 'creatives':
      return t('Banners and carousels on your site.');
    case 'logos':
      return t("Your brand's logos in every format.");
    case 'art-style':
      return t('The look Lumio uses for everything it draws for you.');
    case 'games':
      return t('The game lists on your Homepage and their order.');
    case 'blog':
      return t('Articles that bring players from search.');
    case 'seo':
      return t('How your pages show on Google, in shares and in AI answers.');
  }
};
